module.exports = __webpack_public_path__ + "static/drs-c39c93e4a3236308defe928f9cb32988.png";